// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1GhL4","resendInfoText":"OnGoingPaymentBox_resendInfoText__1G-Kf"};